<template>
  <div class="wrapper">
    <q-linear-progress v-if="this.isFetching || this.loading" indeterminate />
    <NotFoundText v-if="!this.link" />
    <div v-else class="content">
      <CustomSelect
        :options="this.data"
        label="Выберите дату съемки"
        style="width: 250px;"
        optionValueKey="openspace_id"
        optionLabelKey="date_record"
        :value="this.openspace_id"
        @change="(value, row) => onChange(value, row)"
      />
      <iframe
        v-if="!!this.link"
        width="100%"
        height="700px"
        class="iframe"
        @load="this.onLoad"
        :src="this.link"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { getFloorOpenspace } from './services';
import CustomSelect from "@/components/form/CustomSelect";

export default {
  name: "FloorOpenspace",
  components: { CustomSelect },
  props: ['floorMapId'],
  data() {
    return {
      isFetching: false,
      loading: true,
      openspace_id: null,
      link: null,
      data: null,
    }
  },
  methods: {
    async getData() {
      this.isFetching = true
      const res = await getFloorOpenspace(this.floorMapId)
      this.isFetching = false
      if(!res?.length) {
        this.loading = false
        return
      }
      this.data = res || []
      this.link = res[0]?.openspace_url || ''
      this.openspace_id = res[0]?.openspace_id || ''
    },
    onLoad() {
      this.loading = false
    },
    onChange(openspace_id, row) {
      this.openspace_id = openspace_id
      this.link = null
      const timeout = setTimeout(() => {
        this.loading = false
        this.link = row?.openspace_url || ''
        clearTimeout(timeout)
      }, 500)
      this.loading = true
    }
  },
  mounted() {
    this.getData()
  }
};
</script>

<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px
}
.wrapper {
  padding: 20px;
  padding-top: 0;
}
.iframe {
  padding: 20px;
  padding-top: 0;
  margin-top: 20px;
}
</style>
